import { Component } from '@angular/core';
import { HoldStatus } from 'src/app/models/physical-record';
import { RecordButtonsComponent } from '../record-buttons/record-buttons.component';

@Component({
  selector: 'app-cancel-hold-physical-button',
  templateUrl: './cancel-hold-physical-button.component.html',
  styleUrls: ['./cancel-hold-physical-button.component.scss', '../base-button.scss'],
})
export class CancelHoldPhysicalButtonComponent extends RecordButtonsComponent {

  cancelHold() {
    this.doAction(
      () => {
        const hold = this.holdsFacade.getHoldByRecordId(
          this.record.id,
          this.issueDate,
          this.rhId,
          this.physicalRecord.recordId
        );
        this.holdsFacade.deleteHold(hold.id).subscribe(
          () => {
            this.toastService.showToast('messages.holds.cancel');
          },
          () => {},
          () => {
            this.waiting = false;
            this.physicalRecord.holdInfo = HoldStatus.AVAILABLE;
          }
        );
      },
      null,
      true
    );
  }
}
